<div>
    <div class="add-title">
      <h2 class="primary">Reboot device?</h2>
    </div>
    <div>
      <div class="profile-footer">
        <button mat-raised-button class="btn-block change-pw-button" (click)="confirmReboot()">Reboot</button>
        <button mat-raised-button class="btn-block change-pw-button" (click)="closeDialog()">Cancel</button>
      </div>
    </div>
  </div>
